import { HostListener, Directive } from '@angular/core';

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[nameCharacters]'
})
export class NameCharactersDirective {
    constructor() {}

    @HostListener('keypress', ['$event'])
    onKeyPress(event) {
        return (
            (event.charCode >= 65 && event.charCode <= 90) || // A-Z
            (event.charCode >= 97 && event.charCode <= 122) || // a-z
            event.charCode === 32 // space
            // event.charCode === 46 // .
        );
    }

    @HostListener('paste', ['$event'])
    onPaste(event) {
        const format = /[0-9\\`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
        return !format.test(event.clipboardData.getData('text'));
    }
}
